import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { Lock as LockIcon } from "@mui/icons-material";

interface Props {
  open: boolean;
  actionName: string | null;
  onClose: () => void;
}

export const NoPermissionModal = ({ open, actionName, onClose }: Props) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          color: "warning.main",
        }}
      >
        <LockIcon />
        Permission Required
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          You do not have permission to {actionName || "perform this action"}.
          Please contact your administrator if you need access.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
